import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import React from 'react';

type IconProps = Partial<CustomIconComponentProps>;

// #region General

const OperatorComputerSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 29 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M21.7026 22.9265H3.94996C1.76892 22.9265 0 21.1811 0 19.043V8.77652C0 6.6322 1.77526 4.89307 3.94996 4.89307H11.9133C12.4395 4.89307 12.8643 5.31071 12.8643 5.82809C12.8643 6.34546 12.4395 6.76311 11.9133 6.76311H3.94996C2.8214 6.76311 1.90207 7.66696 1.90207 8.77652V19.043C1.90207 20.1526 2.8214 21.0564 3.94996 21.0564H21.7026C22.8311 21.0564 23.7505 20.1526 23.7505 19.043V17.1169C23.7505 16.5995 24.1753 16.1819 24.7015 16.1819C25.2277 16.1819 25.6525 16.5995 25.6525 17.1169V19.043C25.6525 21.1873 23.8773 22.9265 21.7026 22.9265Z'
			fill='#406080'
		/>
		<path d='M18.3103 21.9917H9.17407V25.5822H18.3103V21.9917Z' fill='#406080' />
		<path
			d='M21.0747 15.5837C16.7063 15.5837 13.1494 12.0867 13.1494 7.79184C13.1494 3.49698 16.6999 0 21.0747 0C25.4494 0 29 3.49698 29 7.79184C29 12.0867 25.4431 15.5837 21.0747 15.5837ZM21.0747 1.24669C17.4037 1.24669 14.4175 4.18266 14.4175 7.79184C14.4175 11.401 17.4037 14.337 21.0747 14.337C24.7457 14.337 27.7319 11.401 27.7319 7.79184C27.7319 4.18266 24.7457 1.24669 21.0747 1.24669Z'
			fill='#406080'
		/>
		<path
			d='M21.0743 9.97376C19.1532 9.97376 17.5872 8.43409 17.5872 6.54535C17.5872 4.65661 19.1532 3.11694 21.0743 3.11694C22.9954 3.11694 24.5614 4.65661 24.5614 6.54535C24.5614 8.43409 22.9954 9.97376 21.0743 9.97376ZM21.0743 4.36364C19.8506 4.36364 18.8552 5.34229 18.8552 6.54535C18.8552 7.74841 19.8506 8.72706 21.0743 8.72706C22.2979 8.72706 23.2934 7.74841 23.2934 6.54535C23.2934 5.34229 22.2979 4.36364 21.0743 4.36364Z'
			fill='#406080'
		/>
		<path
			d='M25.5384 13.1526C25.494 13.0217 24.3655 9.9735 21.0749 9.9735C17.7843 9.9735 16.6241 13.1214 16.6177 13.1526L15.4194 12.7474C15.9076 11.3573 17.7146 8.72681 21.0813 8.72681C24.4479 8.72681 26.2549 11.3573 26.7431 12.7474L25.5448 13.1526H25.5384Z'
			fill='#406080'
		/>
	</svg>
);

const QuestionMarkSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.8337 15.8337H9.16699V14.167H10.8337V15.8337ZM12.5587 9.37533L11.8087 10.142C11.2087 10.7503 10.8337 11.2503 10.8337 12.5003H9.16699V12.0837C9.16699 11.167 9.54199 10.3337 10.142 9.72533L11.1753 8.67533C11.4837 8.37533 11.667 7.95866 11.667 7.50033C11.667 6.58366 10.917 5.83366 10.0003 5.83366C9.08366 5.83366 8.33366 6.58366 8.33366 7.50033H6.66699C6.66699 5.65866 8.15866 4.16699 10.0003 4.16699C11.842 4.16699 13.3337 5.65866 13.3337 7.50033C13.3337 8.23366 13.0337 8.90033 12.5587 9.37533Z'
			fill='white'
		/>
	</svg>
);

const QuestionMarkLightSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='10' cy='10' r='10' fill='#849AD5' />
		<path
			d='M10.7144 15H9.2858V13.5714H10.7144V15ZM12.1929 9.46429L11.5501 10.1214C11.0358 10.6429 10.7144 11.0714 10.7144 12.1429H9.2858V11.7857C9.2858 11 9.60723 10.2857 10.1215 9.76429L11.0072 8.86429C11.2715 8.60714 11.4287 8.25 11.4287 7.85714C11.4287 7.07143 10.7858 6.42857 10.0001 6.42857C9.21437 6.42857 8.57152 7.07143 8.57152 7.85714H7.14294C7.14294 6.27857 8.42152 5 10.0001 5C11.5787 5 12.8572 6.27857 12.8572 7.85714C12.8572 8.48571 12.6001 9.05714 12.1929 9.46429Z'
			fill='white'
		/>
	</svg>
);

const QuestionMarkDarkSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='10' cy='10' r='10' fill='#406080' />
		<path
			d='M10.7144 15H9.28586V13.5714H10.7144V15ZM12.193 9.46429L11.5501 10.1214C11.0359 10.6429 10.7144 11.0714 10.7144 12.1429H9.28586V11.7857C9.28586 11 9.60729 10.2857 10.1216 9.76429L11.0073 8.86429C11.2716 8.60714 11.4287 8.25 11.4287 7.85714C11.4287 7.07143 10.7859 6.42857 10.0001 6.42857C9.21443 6.42857 8.57158 7.07143 8.57158 7.85714H7.14301C7.14301 6.27857 8.42158 5 10.0001 5C11.5787 5 12.8573 6.27857 12.8573 7.85714C12.8573 8.48571 12.6001 9.05714 12.193 9.46429Z'
			fill='white'
		/>
	</svg>
);

export const OperatorComputerIcon = (props: IconProps) => <Icon component={OperatorComputerSvg} {...props} />;

export const QuestionMarkIcon = (props: IconProps) => <Icon component={QuestionMarkSVG} {...props} />;
export const QuestionMarkLightIcon = (props: IconProps) => <Icon component={QuestionMarkLightSVG} {...props} />;
export const QuestionMarkDarkIcon = (props: IconProps) => <Icon component={QuestionMarkDarkSVG} {...props} />;

// #endregion

// #region Badge Studio

const BadgeSvg = () => (
	<svg width='1em' height='1em' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 121.1 157.6'>
		<g>
			<g>
				<g>
					<path
						fill='#FFFFFF'
						d='M98.7,138.3H2.6c-1.4,0-2.6-1.2-2.6-2.6V11.9c0-1.4,1.2-2.6,2.6-2.6h22c1.4,0,2.6,1.2,2.6,2.6s-1.2,2.6-2.6,2.6H5.2v118.5h82.7l4.4-10l3.9-8.8V14.5H76.6c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6h22.2c1.4,0,2.6,1.2,2.6,2.6v123.7C101.3,137.1,100.2,138.3,98.7,138.3z'
					/>
				</g>
				<g>
					<path
						fill='#FFFFFF'
						d='M76.6,21.1H24.7c-1.4,0-2.6-1.2-2.6-2.6V4.9c0-1.4,1.2-2.6,2.6-2.6h51.9c1.4,0,2.6,1.2,2.6,2.6v13.6C79.2,20,78,21.1,76.6,21.1z M27.3,15.9H74V7.6H27.3V15.9z'
					/>
				</g>
				<g>
					<path fill='#FFFFFF' d='M37.6,105.5H15.5c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6h22.1c1.4,0,2.6,1.2,2.6,2.6S39,105.5,37.6,105.5z' />
				</g>
				<g>
					<path fill='#FFFFFF' d='M67,105.5H50.7c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6H67c1.4,0,2.6,1.2,2.6,2.6S68.4,105.5,67,105.5z' />
				</g>
				<g>
					<path
						fill='#FFFFFF'
						d='M60.1,92.4H41c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6h19.1c1.4,0,2.6,1.2,2.6,2.6C62.7,91.2,61.6,92.4,60.1,92.4z'
					/>
				</g>
				<g>
					<path fill='#FFFFFF' d='M86.2,105.5h-6.7c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6h6.7c1.4,0,2.6,1.2,2.6,2.6S87.6,105.5,86.2,105.5z' />
				</g>
				<g>
					<path
						fill='#FFFFFF'
						d='M86.2,125.3H64.1c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6h22.1c1.4,0,2.6,1.2,2.6,2.6C88.8,124.1,87.6,125.3,86.2,125.3z'
					/>
				</g>
				<g>
					<path
						fill='#FFFFFF'
						d='M37.6,125.3H15.5c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6h22.1c1.4,0,2.6,1.2,2.6,2.6C40.2,124.1,39,125.3,37.6,125.3z'
					/>
				</g>
				<g>
					<circle fill='#FFFFFF' cx='27.4' cy='89.7' r='3.2' />
				</g>
				<g>
					<circle fill='#FFFFFF' cx='74.2' cy='89.7' r='3.2' />
				</g>
				<g>
					<circle fill='#FFFFFF' cx='50.8' cy='122.6' r='3.2' />
				</g>
				<g>
					<path
						fill='#FFFFFF'
						d='M75.2,78.5h-51c-1.4,0-2.6-1.2-2.6-2.6c0-18.6,14.4-24.3,15-24.5c1.4-0.5,2.9,0.2,3.4,1.5c0.5,1.3-0.2,2.8-1.5,3.4c-0.5,0.2-10.4,4.2-11.6,17h45.5c-1.2-12.8-11.1-16.8-11.6-17c-1.3-0.5-2-2-1.5-3.4c0.5-1.3,2-2,3.4-1.5c0.6,0.2,15,5.9,15,24.5C77.8,77.4,76.6,78.5,75.2,78.5z'
					/>
				</g>
				<g>
					<path
						fill='#FFFFFF'
						d='M49.7,64.9c-9.2,0-16.7-8.6-16.7-19.1c0-10.6,7.5-19.1,16.7-19.1s16.7,8.6,16.7,19.1C66.3,56.3,58.9,64.9,49.7,64.9z M49.7,31.9c-6.3,0-11.5,6.2-11.5,13.9c0,7.7,5.1,13.9,11.5,13.9s11.5-6.2,11.5-13.9C61.1,38.1,56,31.9,49.7,31.9z'
					/>
				</g>
			</g>
			<g>
				<rect x='81.3' y='49.1' transform='matrix(0.9155 0.4023 -0.4023 0.9155 46.98 -28.751)' fill='#FFFFFF' width='21.2' height='96.8' />
				<polygon fill='#FFFFFF' points='62.7,137.5 82.2,146.1 65.8,156.9' />
			</g>
		</g>
	</svg>
);

const MagStripeSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 20 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect width='1.07143' height='9' fill='#475376' />
		<rect x='18.2144' width='1.07143' height='9' fill='#475376' />
		<rect x='2.67871' width='3.21429' height='7.39286' fill='#475376' />
		<rect x='12.3213' width='4.28571' height='7.39286' fill='#475376' />
		<rect x='6.96436' width='1.07143' height='7.39286' fill='#475376' />
		<rect x='9.64307' width='1.07143' height='7.39286' fill='#475376' />
		<rect x='2.67871' y='8.03564' width='3.21429' height='0.964286' fill='#475376' />
		<rect x='12.3213' y='8.03564' width='4.28571' height='0.964286' fill='#475376' />
		<rect x='6.96436' y='8.03564' width='1.07143' height='0.964286' fill='#475376' />
		<rect x='9.64307' y='8.03564' width='1.07143' height='0.964286' fill='#475376' />
		<rect x='9.5' y='1.5' width='4' height='13' rx='1.5' fill='white' stroke='#475376' />
	</svg>
);

const SignatureSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M1 10.9084V14.3084L4.4 13.7417L13.4667 4.67502L10.35 1.55835L1 10.9084Z' stroke='#475376' strokeLinecap='round' />
		<path
			d='M3.5498 17.9915C6.00536 18.086 11.6531 17.4249 14.5998 14.0249C15.5065 12.2115 13.8443 11.5693 12.8998 11.4749C11.9554 11.5693 10.0665 12.2115 10.0665 14.0249C10.0665 15.8382 11.9554 16.8582 12.8998 17.1415C13.8443 17.5193 16.1865 17.6515 17.9998 15.1582'
			stroke='#475376'
			strokeLinecap='round'
		/>
	</svg>
);

const InDesignSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='10.8553' cy='10.8553' r='10.8553' fill='#F57600' />
		<path d='M13.1402 6L10.2002 8.94L15.2402 13.98L18.1802 11.04L13.1402 6Z' stroke='white' strokeWidth='0.5' strokeLinecap='round' />
		<path d='M10.2 15.78L11.5 14.5L9.4 12.4L6 15.78H10.2Z' stroke='white' strokeWidth='0.5' strokeLinecap='round' />
		<path d='M10.7968 9.78003L8.93994 11.6369L12.1231 14.82L13.9799 12.9632L10.7968 9.78003Z' stroke='white' strokeWidth='0.5' strokeLinecap='round' />
		<path d='M8.5 16H4' stroke='white' strokeWidth='0.5' strokeLinecap='round' />
	</svg>
);

const DesignSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='10.8553' cy='10.8553' r='10.8553' fill='#686D98' />
		<path d='M13.1402 6L10.2002 8.94L15.2402 13.98L18.1802 11.04L13.1402 6Z' stroke='white' strokeWidth='0.5' strokeLinecap='round' />
		<path d='M10.2 15.7799L11.5 14.4999L9.4 12.3999L6 15.7799H10.2Z' stroke='white' strokeWidth='0.5' strokeLinecap='round' />
		<path d='M10.7968 9.78003L8.93994 11.6369L12.1231 14.82L13.9799 12.9632L10.7968 9.78003Z' stroke='white' strokeWidth='0.5' strokeLinecap='round' />
		<path d='M8.5 16H4' stroke='white' strokeWidth='0.5' strokeLinecap='round' />
	</svg>
);

const InPreviewSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='10.8553' cy='10.8553' r='10.8553' fill='#11B5E4' />
		<path
			d='M10.8682 6C7.39586 6 4.25869 9.08484 3.12414 10.6273C2.89931 10.917 3.03046 11.4312 3.12414 11.6521C4.25869 13.2152 7.39586 16.3415 10.8682 16.3415C15.2086 16.3415 18.5498 12.18 18.8621 11.6521C19.1119 11.2297 18.9662 10.7929 18.8621 10.6273C17.6443 9.08484 14.3405 6 10.8682 6Z'
			fill='white'
		/>
		<circle cx='10.9024' cy='11.1707' r='3.41463' fill='#D9D9D9' />
		<circle cx='10.9027' cy='11.1707' r='1.65854' fill='#2D3047' />
	</svg>
);

const PreviewSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='10.8553' cy='10.8553' r='10.8553' fill='#686D98' />
		<path
			d='M10.8682 6C7.39586 6 4.25869 9.08484 3.12414 10.6273C2.89931 10.917 3.03046 11.4312 3.12414 11.6521C4.25869 13.2152 7.39586 16.3415 10.8682 16.3415C15.2086 16.3415 18.5498 12.18 18.8621 11.6521C19.1119 11.2297 18.9662 10.7929 18.8621 10.6273C17.6443 9.08484 14.3405 6 10.8682 6Z'
			fill='white'
		/>
		<circle cx='10.9024' cy='11.1707' r='3.41463' fill='#D9D9D9' />
		<circle cx='10.9027' cy='11.1707' r='1.65854' fill='#2D3047' />
	</svg>
);

const SelectArrowSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 17 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M2.25928 11.6277L5.91814 1.61001L14.1855 8.43206L2.25928 11.6277Z' fill='#233B53' stroke='#233B53' strokeLinejoin='round' />
		<rect x='7.11042' y='9.62821' width='2' height='9' transform='rotate(-15 7.11042 9.62821)' fill='#233B53' stroke='#233B53' strokeLinejoin='round' />
	</svg>
);

const FreeHandSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M1.34979 5.61848C3.34979 2.78515 7.24979 -1.68152 6.84979 3.11848C6.44979 7.91848 3.34981 10.333 1.84977 13.1187C0.349732 15.9044 -0.0502086 20.2187 8.34979 16.6187C16.7498 13.0187 18.1831 7.7852 17.8497 5.61848'
			strokeLinecap='round'
		/>
	</svg>
);

const FilledRectangleSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 24 16' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.5' y='0.5' width='23' height='15' />
	</svg>
);

const FilledCircleSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='8' cy='8' r='7.5' fill-opacity='0.4' />
	</svg>
);

const AddTextSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 14 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M12.46 8.66H11.86L10.92 6.36L7.7 6.32V18.34L9.56 18.52V19H3.18V18.52L5.04 18.34V6.32L1.82 6.36L0.88 8.66H0.3V5.64L6.38 5.6L12.46 5.64V8.66Z'
			fill='#233B53'
		/>
		<circle cx='10.8347' cy='17.3565' r='3.16522' fill='#406080' />
		<path d='M10.8345 15.6522V19.0609' stroke='white' strokeLinecap='round' />
		<path d='M9.13037 17.3571L12.5391 17.3571' stroke='white' strokeLinecap='round' />
	</svg>
);

const ExpandSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
		<rect width='30' height='30' />
		<rect x='15' y='1' width='20' height='20' transform='rotate(45 15 1)' fill='url(#pattern0_96_6633)' />
		<defs>
			<pattern id='pattern0_96_6633' patternContentUnits='objectBoundingBox' width='1' height='1'>
				<use xlinkHref='#image0_96_6633' transform='scale(0.00195312)' />
			</pattern>
			<image
				id='image0_96_6633'
				width='512'
				height='512'
				xlinkHref='data:image/png;base64,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'
			/>
		</defs>
	</svg>
);

export const BadgeStudioIcon = (props: IconProps) => <Icon component={BadgeSvg} {...props} />;

export const MagStripeIcon = (props: IconProps) => <Icon component={MagStripeSvg} {...props} />;

export const SignatureIcon = (props: IconProps) => <Icon component={SignatureSvg} {...props} />;

export const InDesignIcon = (props: IconProps) => <Icon component={InDesignSvg} {...props} />;

export const DesignIcon = (props: IconProps) => <Icon component={DesignSvg} {...props} />;

export const InPreviewIcon = (props: IconProps) => <Icon component={InPreviewSvg} {...props} />;

export const PreviewIcon = (props: IconProps) => <Icon component={PreviewSvg} {...props} />;

export const SelectArrowIcon = (props: IconProps) => <Icon component={SelectArrowSvg} {...props} />;

export const FreeHandIcon = (props: IconProps) => <Icon component={FreeHandSvg} {...props} />;

export const FilledRectangleIcon = (props: IconProps) => <Icon component={FilledRectangleSvg} {...props} />;

export const FilledCircleIcon = (props: IconProps) => <Icon component={FilledCircleSvg} {...props} />;

export const AddTextIcon = (props: IconProps) => <Icon component={AddTextSvg} {...props} />;

export const ExpandIcon = (props: IconProps) => <Icon component={ExpandSvg} {...props} />;

// #endregion

// #region Graphics Menu

const MapDesignCircleSvg = () => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 34.49 34.49'
		xmlSpace='preserve'
		width='1em'
		height='1em'>
		<circle style={{ fill: '#11B5E4' }} cx='17.25' cy='17.25' r='16.69' />
		<g>
			<path
				style={{ fill: '#FFFFFF' }}
				d='M23.76,28.11c-0.15-0.11-0.32-0.2-0.46-0.33c-1.65-1.64-3.29-3.29-4.94-4.93c-0.05-0.05-0.11-0.09-0.14-0.12
		c1.51-1.51,3-3,4.48-4.48c0.36,0.36,0.75,0.75,1.16,1.16c-0.41,0.41-0.84,0.84-1.27,1.27c-0.18,0.18-0.28,0.39-0.21,0.65
		c0.12,0.49,0.7,0.65,1.07,0.29c0.4-0.38,0.78-0.78,1.17-1.17c0.05-0.05,0.1-0.1,0.13-0.13c0.3,0.3,0.59,0.59,0.9,0.9
		c-0.27,0.27-0.58,0.58-0.88,0.88c-0.13,0.12-0.25,0.25-0.37,0.38c-0.3,0.31-0.32,0.69-0.05,0.96c0.27,0.26,0.64,0.24,0.94-0.05
		c0.38-0.38,0.76-0.76,1.14-1.14c0.05-0.05,0.1-0.1,0.14-0.14c0.48,0.47,0.95,0.92,1.41,1.39c0.07,0.07,0.1,0.17,0.14,0.26
		c0,0.1,0,0.2,0,0.3c-0.13,0.16-0.25,0.34-0.39,0.49c-1.06,1.07-2.12,2.13-3.19,3.19c-0.15,0.15-0.32,0.26-0.49,0.39
		C23.96,28.11,23.86,28.11,23.76,28.11z'
			/>
			<path
				style={{ fill: '#FFFFFF' }}
				d='M28.13,10.2c-0.04,0.17-0.05,0.35-0.13,0.51c-0.13,0.26-0.27,0.51-0.45,0.73c-0.27,0.32-0.58,0.59-0.86,0.87
		c-1.5-1.5-2.99-2.99-4.51-4.51c0.38-0.36,0.75-0.76,1.18-1.09c0.65-0.49,1.63-0.45,2.24,0.1c0.7,0.64,1.36,1.34,2.03,2.01
		c0.31,0.31,0.42,0.71,0.5,1.12C28.13,10.03,28.13,10.12,28.13,10.2z'
			/>
			<path
				style={{ fill: '#FFFFFF' }}
				d='M6.48,27.14c0.52-1.55,1.03-3.11,1.55-4.66c0.02-0.07,0.05-0.14,0.07-0.2c1.37,1.37,2.74,2.74,4.12,4.12
		c-1.7,0.57-3.4,1.14-5.11,1.71c-0.06,0-0.11,0-0.17,0l-0.59,0.01V27.6'
			/>
			<path
				style={{ fill: '#FFFFFF' }}
				d='M12.49,7.92c-0.45,0.44-0.87,0.88-1.31,1.3c-0.17,0.17-0.27,0.37-0.22,0.61c0.05,0.24,0.19,0.41,0.42,0.49
		c0.24,0.08,0.46,0.03,0.65-0.15C12.42,9.78,12.81,9.39,13.2,9c0.05-0.05,0.1-0.12,0.13-0.16c0.32,0.32,0.61,0.61,0.92,0.92
		c-0.33,0.33-0.68,0.67-1.02,1.02c-0.1,0.1-0.2,0.2-0.3,0.3c-0.24,0.27-0.24,0.64,0,0.88c0.24,0.25,0.63,0.27,0.89,0.01
		c0.43-0.41,0.84-0.84,1.26-1.26c0.02-0.02,0.05-0.05,0.06-0.05c0.39,0.4,0.79,0.79,1.16,1.16c-1.46,1.46-2.95,2.95-4.45,4.46
		c-0.03-0.03-0.08-0.07-0.13-0.12c-1.66-1.66-3.32-3.32-4.98-4.98c-0.4-0.4-0.4-0.72,0.01-1.12C7.88,8.93,9,7.8,10.13,6.68
		c0.39-0.39,0.72-0.4,1.11-0.01C11.65,7.08,12.06,7.49,12.49,7.92z'
			/>
			<path
				style={{ fill: '#FFFFFF' }}
				d='M19.48,10.61c0.56,0.56,3.86,3.86,4.44,4.44c-3.51,3.51-7.05,7.05-10.56,10.57c-0.58-0.57-3.87-3.87-4.44-4.44
		C12.42,17.66,15.96,14.13,19.48,10.61z'
			/>
			<path
				style={{ fill: '#FFFFFF' }}
				d='M25.72,13.25c-0.27,0.27-0.56,0.56-0.83,0.83c-1.48-1.48-2.98-2.98-4.46-4.46c0.26-0.26,0.55-0.55,0.83-0.83
		C22.74,10.27,24.23,11.77,25.72,13.25z'
			/>
		</g>
	</svg>
);

const MapDesignSvg = () => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 22.32 22.32'
		xmlSpace='preserve'
		width='1em'
		height='1em'>
		<g>
			<path
				style={{ fill: '#FFF' }}
				d='M17.67,22.03c-0.15-0.11-0.32-0.2-0.46-0.33c-1.65-1.64-3.29-3.29-4.94-4.93c-0.05-0.05-0.11-0.09-0.14-0.12
		c1.51-1.51,3-3,4.48-4.48c0.36,0.36,0.75,0.75,1.16,1.16c-0.41,0.41-0.84,0.84-1.27,1.27c-0.18,0.18-0.28,0.39-0.21,0.65
		c0.12,0.49,0.7,0.65,1.07,0.29c0.4-0.38,0.78-0.78,1.17-1.17c0.05-0.05,0.1-0.1,0.13-0.13c0.3,0.3,0.59,0.59,0.9,0.9
		c-0.27,0.27-0.58,0.58-0.88,0.88c-0.13,0.12-0.25,0.25-0.37,0.38c-0.3,0.31-0.32,0.69-0.05,0.96c0.27,0.26,0.64,0.24,0.94-0.05
		c0.38-0.38,0.76-0.76,1.14-1.14c0.05-0.05,0.1-0.1,0.14-0.14c0.48,0.47,0.95,0.92,1.41,1.39c0.07,0.07,0.1,0.17,0.14,0.26
		c0,0.1,0,0.2,0,0.3c-0.13,0.16-0.25,0.34-0.39,0.49c-1.06,1.07-2.12,2.13-3.19,3.19c-0.15,0.15-0.32,0.26-0.49,0.39
		C17.87,22.03,17.77,22.03,17.67,22.03z'
			/>
			<path
				style={{ fill: '#FFF' }}
				d='M22.05,4.11C22,4.28,21.99,4.47,21.92,4.62c-0.13,0.26-0.27,0.51-0.45,0.73c-0.27,0.32-0.58,0.59-0.86,0.87
		c-1.5-1.5-2.99-2.99-4.51-4.51c0.38-0.36,0.75-0.76,1.18-1.09c0.65-0.49,1.63-0.45,2.24,0.1c0.7,0.64,1.36,1.34,2.03,2.01
		c0.31,0.31,0.42,0.71,0.5,1.12C22.05,3.94,22.05,4.03,22.05,4.11z'
			/>
			<path
				style={{ fill: '#FFF' }}
				d='M0.39,21.05c0.52-1.55,1.03-3.11,1.55-4.66c0.02-0.07,0.05-0.14,0.07-0.2c1.37,1.37,2.74,2.74,4.12,4.12
		c-1.7,0.57-3.4,1.14-5.11,1.71c-0.06,0-0.11,0-0.17,0l-0.59,0.01v-0.52'
			/>
			<path
				style={{ fill: '#FFF' }}
				d='M6.4,1.83c-0.45,0.44-0.87,0.88-1.31,1.3C4.92,3.3,4.83,3.5,4.87,3.74C4.92,3.98,5.07,4.16,5.3,4.23
		c0.24,0.08,0.46,0.03,0.65-0.15C6.34,3.69,6.73,3.3,7.12,2.91c0.05-0.05,0.1-0.12,0.13-0.16c0.32,0.32,0.61,0.61,0.92,0.92
		C7.84,3.99,7.49,4.34,7.14,4.69c-0.1,0.1-0.2,0.2-0.3,0.3c-0.24,0.27-0.24,0.64,0,0.88c0.24,0.25,0.63,0.27,0.89,0.01
		C8.17,5.47,8.58,5.05,9,4.63C9.03,4.6,9.05,4.58,9.06,4.57c0.39,0.4,0.79,0.79,1.16,1.16C8.76,7.2,7.27,8.69,5.77,10.19
		c-0.03-0.03-0.08-0.07-0.13-0.12C3.98,8.41,2.32,6.75,0.66,5.09c-0.4-0.4-0.4-0.72,0.01-1.12c1.12-1.13,2.25-2.25,3.38-3.38
		c0.39-0.39,0.72-0.4,1.11-0.01C5.56,0.99,5.97,1.4,6.4,1.83z'
			/>
			<path
				style={{ fill: '#FFF' }}
				d='M13.39,4.52c0.56,0.56,3.86,3.86,4.44,4.44c-3.51,3.51-7.05,7.05-10.56,10.57c-0.58-0.57-3.87-3.87-4.44-4.44
		C6.34,11.58,9.87,8.04,13.39,4.52z'
			/>
			<path
				style={{ fill: '#FFF' }}
				d='M19.63,7.16c-0.27,0.27-0.56,0.56-0.83,0.83c-1.48-1.48-2.98-2.98-4.46-4.46c0.26-0.26,0.55-0.55,0.83-0.83
		C16.65,4.19,18.15,5.68,19.63,7.16z'
			/>
		</g>
	</svg>
);

const PublishSvg = () => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 22.32 22.32'
		xmlSpace='preserve'
		width='1em'
		height='1em'>
		<path
			style={{ fill: '#BEBEBE' }}
			d='M2.28,5.7L2.28,5.7c0.75,0,1.37,0.61,1.37,1.37v13.66c0,0.75-0.61,1.37-1.37,1.37l0,0
	c-0.75,0-1.37-0.61-1.37-1.37V7.06C0.92,6.31,1.53,5.7,2.28,5.7z'
		/>
		<g>
			<path style={{ fill: '#FFFFFF' }} d='M7.94,14.07H5.51v2.43C6.87,16.42,7.91,15.18,7.94,14.07z' />
			<path
				style={{ fill: '#FFFFFF' }}
				d='M12.63,8.63h0.71c0-0.1,0-0.19,0.02-0.28c0.02-0.13,0.11-0.21,0.24-0.2c0.12,0,0.23,0.07,0.23,0.2
		c0,0.36,0,0.72,0,1.08c0,0.13-0.1,0.19-0.23,0.19c-0.13,0-0.22-0.07-0.23-0.2c-0.01-0.08-0.02-0.18-0.02-0.29
		c-0.06,0-0.09,0-0.14,0c-0.23,0-0.46,0-0.69,0c-0.33,0-0.38-0.05-0.38-0.38c0-0.8,0-1.6,0-2.4V6.19H9.94v1.46c0.08,0,0.16,0,0.24,0
		c0.15,0.02,0.24,0.11,0.23,0.25c0,0.14-0.09,0.23-0.25,0.23c-0.32,0-0.64,0-0.95,0c-0.17,0-0.26-0.09-0.26-0.23
		c0-0.15,0.08-0.23,0.25-0.25c0.08,0,0.15,0,0.22,0V6.19H5.51v5.4h3.91v-1.45c-0.09,0-0.18,0-0.27-0.02C9.01,10.1,8.93,10,8.94,9.87
		c0-0.13,0.08-0.23,0.23-0.23c0.34,0,0.69,0,1.02,0c0.14,0,0.22,0.1,0.23,0.23c0,0.13-0.08,0.23-0.22,0.24
		c-0.08,0.01-0.18,0.01-0.27,0.02c0,0.54,0,1.07,0,1.6c0,0.3-0.07,0.37-0.37,0.37c-1.3,0-2.58,0-3.88,0H5.51v1.47h0.17
		c0.82,0,1.64,0,2.46,0c0.23,0,0.32,0.09,0.31,0.31c-0.04,1.39-0.91,2.55-2.22,2.97c-0.23,0.08-0.47,0.11-0.71,0.17v0.47h5.4v-0.18
		c0-1.3,0-2.6,0-3.9c0-0.26,0.08-0.34,0.34-0.34c0.49,0,0.98,0,1.46,0h0.15c0-0.1,0-0.19,0.02-0.27c0.02-0.14,0.11-0.22,0.24-0.22
		s0.23,0.08,0.23,0.23c0,0.34,0,0.68,0,1.02c0,0.14-0.09,0.22-0.23,0.23c-0.13,0-0.23-0.08-0.24-0.22
		c-0.01-0.08-0.01-0.18-0.02-0.26H11.4v3.91h5.39v-3.91h-1.46c0,0.08,0,0.15,0,0.23c-0.01,0.17-0.1,0.25-0.25,0.25
		s-0.23-0.09-0.23-0.26c0-0.31,0-0.62,0-0.94c0-0.17,0.09-0.26,0.23-0.26c0.14,0,0.23,0.09,0.25,0.25c0,0.08,0,0.15,0,0.23h1.46
		V9.15h-0.98c0,0.08,0,0.16,0,0.24c-0.02,0.16-0.1,0.24-0.25,0.23c-0.14,0-0.23-0.09-0.23-0.25c0-0.32,0-0.64,0-0.95
		c0-0.17,0.09-0.26,0.24-0.26s0.23,0.09,0.24,0.26c0,0.07,0,0.14,0,0.22h0.98V6.19h-4.16V8.63z'
			/>
			<path
				style={{ fill: '#FFFFFF' }}
				d='M19.84,4.33H2.48c-0.86,0-1.56,0.7-1.56,1.56v11.9c0,0.86,0.7,1.56,1.56,1.56h17.36c0.86,0,1.56-0.7,1.56-1.56
		V5.89C21.4,5.03,20.7,4.33,19.84,4.33z M17.31,17.66c0,0.25-0.08,0.33-0.35,0.33c-1.46,0-2.94,0-4.4,0c-2.37,0-4.73,0-7.1,0
		c-0.05,0-0.08,0-0.13,0c-0.23,0-0.31-0.08-0.31-0.32c0-0.02,0-0.04,0-0.06c0-3.85,0-7.69,0-11.54c-0.01-0.16,0-0.29,0.15-0.38
		h11.96c0.13,0.07,0.18,0.17,0.18,0.32C17.31,9.9,17.31,13.78,17.31,17.66z'
			/>
		</g>
		<path style={{ fill: '#BEBEBE' }} d='M18.67,1.6c0-0.75,0.61-1.37,1.37-1.37l0,0c0.75,0,1.37,0.61,1.37,1.37v16.39l-2.73-1.43V1.6z' />
	</svg>
);

const PublishCircleSvg = () => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 34.49 34.49'
		xmlSpace='preserve'
		width='1em'
		height='1em'>
		<circle cx='17.25' cy='17.25' r='16.69' style={{ fill: '#686D98' }} />
		<g>
			<path
				style={{ fill: '#BEBEBE' }}
				d='M8.37,11.78L8.37,11.78c0.75,0,1.37,0.61,1.37,1.37v13.66c0,0.75-0.61,1.37-1.37,1.37l0,0
		C7.62,28.18,7,27.57,7,26.81V13.14C7.01,12.39,7.62,11.78,8.37,11.78z'
			/>
			<g>
				<path style={{ fill: '#FFFFFF' }} d='M14.03,20.15H11.6v2.43C12.96,22.5,14,21.26,14.03,20.15z' />
				<path
					style={{ fill: '#FFFFFF' }}
					d='M18.72,14.71h0.71c0-0.1,0-0.19,0.02-0.28c0.02-0.13,0.11-0.21,0.24-0.2c0.12,0,0.23,0.07,0.23,0.2
			c0,0.36,0,0.72,0,1.08c0,0.13-0.1,0.19-0.23,0.19c-0.13,0-0.22-0.07-0.23-0.2c-0.01-0.08-0.02-0.18-0.02-0.29
			c-0.06,0-0.09,0-0.14,0c-0.23,0-0.46,0-0.69,0c-0.33,0-0.38-0.05-0.38-0.38c0-0.8,0-1.6,0-2.4v-0.16h-2.2v1.46
			c0.08,0,0.16,0,0.24,0c0.15,0.02,0.24,0.11,0.23,0.25c0,0.14-0.09,0.23-0.25,0.23c-0.32,0-0.64,0-0.95,0
			c-0.17,0-0.26-0.09-0.26-0.23c0-0.15,0.08-0.23,0.25-0.25c0.08,0,0.15,0,0.22,0v-1.46H11.6v5.4h3.91v-1.45
			c-0.09,0-0.18,0-0.27-0.02c-0.14-0.02-0.22-0.12-0.21-0.25c0-0.13,0.08-0.23,0.23-0.23c0.34,0,0.69,0,1.02,0
			c0.14,0,0.22,0.1,0.23,0.23c0,0.13-0.08,0.23-0.22,0.24c-0.08,0.01-0.18,0.01-0.27,0.02c0,0.54,0,1.07,0,1.6
			c0,0.3-0.07,0.37-0.37,0.37c-1.3,0-2.58,0-3.88,0H11.6v1.47h0.17c0.82,0,1.64,0,2.46,0c0.23,0,0.32,0.09,0.31,0.31
			c-0.04,1.39-0.91,2.55-2.22,2.97c-0.23,0.08-0.47,0.11-0.71,0.17v0.47h5.4v-0.18c0-1.3,0-2.6,0-3.9c0-0.26,0.08-0.34,0.34-0.34
			c0.49,0,0.98,0,1.46,0h0.15c0-0.1,0-0.19,0.02-0.27c0.02-0.14,0.11-0.22,0.24-0.22c0.13,0,0.23,0.08,0.23,0.23
			c0,0.34,0,0.68,0,1.02c0,0.14-0.09,0.22-0.23,0.23c-0.13,0-0.23-0.08-0.24-0.22c-0.01-0.08-0.01-0.18-0.02-0.26h-1.47v3.91h5.39
			v-3.91h-1.46c0,0.08,0,0.15,0,0.23c-0.01,0.17-0.1,0.25-0.25,0.25s-0.23-0.09-0.23-0.26c0-0.31,0-0.62,0-0.94
			c0-0.17,0.09-0.26,0.23-0.26c0.14,0,0.23,0.09,0.25,0.25c0,0.08,0,0.15,0,0.23h1.46v-3.93H21.9c0,0.08,0,0.16,0,0.24
			c-0.02,0.16-0.1,0.24-0.25,0.23c-0.14,0-0.23-0.09-0.23-0.25c0-0.32,0-0.64,0-0.95c0-0.17,0.09-0.26,0.24-0.26
			s0.23,0.09,0.24,0.26c0,0.07,0,0.14,0,0.22h0.98v-2.45h-4.16C18.72,12.27,18.72,14.71,18.72,14.71z'
				/>
				<path
					style={{ fill: '#FFFFFF' }}
					d='M25.93,10.41H8.57c-0.86,0-1.56,0.7-1.56,1.56v11.9c0,0.86,0.7,1.56,1.56,1.56h17.36
			c0.86,0,1.56-0.7,1.56-1.56v-11.9C27.49,11.11,26.79,10.41,25.93,10.41z M23.4,23.74c0,0.25-0.08,0.33-0.35,0.33
			c-1.46,0-2.94,0-4.4,0c-2.37,0-4.73,0-7.1,0c-0.05,0-0.08,0-0.13,0c-0.23,0-0.31-0.08-0.31-0.32c0-0.02,0-0.04,0-0.06
			c0-3.85,0-7.69,0-11.54c-0.01-0.16,0-0.29,0.15-0.38h11.96c0.13,0.07,0.18,0.17,0.18,0.32C23.4,15.98,23.4,19.86,23.4,23.74z'
				/>
			</g>
			<path style={{ fill: '#BEBEBE' }} d='M24.76,7.68c0-0.75,0.61-1.37,1.37-1.37l0,0c0.75,0,1.37,0.61,1.37,1.37v16.39l-2.73-1.43V7.68H24.76z' />
		</g>
	</svg>
);

const LineWeightSvg = () => (
	<svg width='1em' height='1em' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M1 11H14.5' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
		<path d='M1 6H14.5' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
		<path d='M1 1H14.5' stroke='black' strokeWidth='0.5' strokeLinecap='round' strokeLinejoin='round' />
	</svg>
);

export const MapDesignCircleIcon = (props: IconProps) => <Icon component={MapDesignCircleSvg} {...props} />;

export const MapDesignIcon = (props: IconProps) => <Icon component={MapDesignSvg} {...props} />;

export const PublishIcon = (props: IconProps) => <Icon component={PublishSvg} {...props} />;

export const PublishCircleIcon = (props: IconProps) => <Icon component={PublishCircleSvg} {...props} />;

export const LineWeight = (props: IconProps) => <Icon component={LineWeightSvg} {...props} />;

// #endregion

// #region Roles

const ClosedFolderSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 18 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M6.5 1H1V14.3333L17 14.3531V3.05432L8.5 3.05432L6.5 1Z' fill='#F2D841' stroke='#F2D841' />
		<rect x='2' y='5' width='14' height='9' fill='white' />
		<rect x='2' y='4' width='14' height='1' fill='#D1E6FA' />
		<path d='M17.5 5H12.5L9.5 6.5H0.5V15H17.5V5Z' fill='#F6BE4E' />
	</svg>
);

const OpenedFolderSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 22 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M6.5 1H1V14.3333L17 14.3531V3.05432L8.5 3.05432L6.5 1Z' fill='#F2D841' stroke='#F2D841' />
		<rect x='2' y='5' width='14' height='9' fill='white' />
		<rect x='2' y='4' width='14' height='1' fill='#D1E6FA' />
		<path d='M21.5 6.5H16.5L13.5 8H4.5L0.5 15H17.5L21.5 6.5Z' fill='#F6BE4E' />
	</svg>
);

const AppliedFilterSVG = () => (
	<svg width='18' height='16' viewBox='0 0 18 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M17 1H1L6.33333 9.55556V15H11.6667V9.55556L17 1Z' fill='#406080' stroke='#406080' />
	</svg>
);

export const ClosedFolderIcon = (props: IconProps) => <Icon component={ClosedFolderSVG} {...props} />;

export const OpenedFolderIcon = (props: IconProps) => <Icon component={OpenedFolderSVG} {...props} />;

export const AppliedFilterIcon = (props: IconProps) => <Icon component={AppliedFilterSVG} {...props} />;

// #endregion

// #region Enrollment
const AddPersonGroupSVG = () => (
	<svg width='1em' height='1em' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 90' xmlSpace='preserve'>
		<g>
			<circle style={{ fill: '#3F6080' }} cx='35.9' cy='21.2' r='19.2' />
			<path
				style={{ fill: '#3F6080' }}
				d='M63.6,77.4c0.3-0.3,0.3-0.6,0.1-1c-0.3-0.6-0.6-1.3-0.8-2c-0.1-0.4-0.3-0.5-0.7-0.6c-1.5-0.2-3.1-0.4-4.6-0.7
		c-0.9-0.1-1.2-0.4-1.2-1.4c0-2.1,0-4.1,0-6.2c0-0.9,0.3-1.2,1.2-1.4c1.6-0.2,3.2-0.5,4.8-0.7c0.2,0,0.4-0.2,0.4-0.3
		c0.3-0.7,0.6-1.4,0.9-2.2c0.1-0.2,0-0.5-0.1-0.6c-0.9-1.2-1.8-2.4-2.8-3.6c-0.6-0.8-0.7-1.1,0-1.9c0.9-1,1.8-1.9,2.7-2.8
		c-9-12.2-27.7-11.6-27.7-11.6s-32.4-1-32.4,27.3v10.6h59.3C63.1,78.1,63.3,77.7,63.6,77.4z'
			/>
			<path
				style={{ fill: '#3F6080' }}
				d='M95.2,58c-0.1,0.3-0.2,0.5-0.4,0.7c-0.8,1-1.5,2-2.3,3c-0.2,0.2-0.2,0.4-0.1,0.7c0.3,0.6,0.5,1.2,0.7,1.8
		c0.1,0.3,0.2,0.3,0.5,0.4c1.3,0.2,2.7,0.4,4,0.6c0.6,0.1,0.9,0.4,0.9,1c0,1.8,0,3.6,0,5.4c0,0.6-0.3,0.9-0.9,1
		c-1.4,0.2-2.7,0.4-4.1,0.6c-0.1,0-0.3,0.2-0.4,0.3c-0.3,0.6-0.5,1.2-0.8,1.8c-0.1,0.1,0,0.4,0.1,0.5c0.8,1,1.5,2,2.3,3
		c0.6,0.7,0.6,1,0,1.6c-1.2,1.2-2.3,2.5-3.6,3.6c-1,0.9-1.2,0.8-2.2,0c-0.9-0.7-1.8-1.4-2.7-2.1c-0.2-0.2-0.3-0.2-0.6-0.1
		c-0.6,0.3-1.1,0.5-1.7,0.7c-0.2,0.1-0.3,0.2-0.3,0.4c-0.2,1.3-0.4,2.7-0.6,4c-0.2,0.9-0.4,1-1.3,1c-1.7,0-3.3,0-5,0
		c-0.8,0-1-0.2-1.2-1c-0.2-1.3-0.4-2.6-0.6-3.9c-0.1-0.4-0.2-0.6-0.6-0.7c-0.5-0.1-1-0.3-1.4-0.6c-0.3-0.1-0.5-0.1-0.7,0.1
		c-1,0.8-2.1,1.6-3.1,2.4c-0.6,0.4-0.9,0.4-1.5-0.1c-1.3-1.3-2.6-2.6-3.8-3.9c-0.5-0.5-0.5-0.9,0-1.5c0.7-1,1.5-1.9,2.2-2.9
		c0.2-0.3,0.3-0.5,0.1-0.8c-0.3-0.5-0.5-1.1-0.7-1.7c-0.1-0.3-0.2-0.4-0.6-0.5c-1.3-0.2-2.6-0.4-3.9-0.6c-0.8-0.1-1-0.4-1-1.1
		c0-1.7,0-3.4,0-5.2c0-0.8,0.2-1,1-1.2c1.3-0.2,2.7-0.4,4-0.6c0.1,0,0.3-0.2,0.4-0.3c0.3-0.6,0.5-1.2,0.8-1.8c0.1-0.2,0-0.4-0.1-0.5
		c-0.8-1-1.5-2-2.3-3c-0.5-0.7-0.6-0.9,0-1.6c1.2-1.3,2.4-2.5,3.6-3.7c0.9-0.9,1.1-0.8,2.1,0c0.9,0.7,1.9,1.4,2.8,2.2
		c0.2,0.2,0.4,0.2,0.6,0.1c0.6-0.3,1.1-0.5,1.7-0.7c0.1-0.1,0.3-0.2,0.3-0.4c0.2-1.3,0.4-2.7,0.6-4c0.2-0.9,0.4-1,1.3-1
		c1.7,0,3.4,0,5.1,0c0.8,0,1,0.2,1.1,0.9c0.2,1.3,0.4,2.6,0.6,3.9c0,0.3,0.2,0.5,0.5,0.6c0.5,0.2,1,0.4,1.5,0.6
		c0.2,0.1,0.4,0.1,0.5-0.1c1.1-0.8,2.2-1.7,3.3-2.5c0.4-0.3,0.9-0.3,1.2,0c1.3,1.3,2.7,2.7,4,4.1C95,57.4,95,57.7,95.2,58z
		 M79.4,62.4c-3.6,0-6.4,2.8-6.4,6.4c0,3.6,2.8,6.4,6.4,6.4c3.6,0,6.4-2.8,6.4-6.4C85.8,65.2,83,62.4,79.4,62.4z'
			/>
		</g>
	</svg>
);

export const AddPersonGroupIcon = (props: IconProps) => <Icon component={AddPersonGroupSVG} {...props} />;
// #endregion

// #region Header
const UserSVG = () => (
	<svg height='1em' width='1em' viewBox='0 0 16 16' fill='currentColor' aria-hidden xmlns='http://www.w3.org/2000/svg'>
		<path d='M12.7221 13.4397H2.31548C1.03695 13.4397 0 12.4166 0 11.1632V5.14493C0 3.88793 1.04066 2.86844 2.31548 2.86844H6.9836C7.29209 2.86844 7.5411 3.11326 7.5411 3.41655C7.5411 3.71984 7.29209 3.96466 6.9836 3.96466H2.31548C1.65391 3.96466 1.115 4.4945 1.115 5.14493V11.1632C1.115 11.8136 1.65391 12.3435 2.31548 12.3435H12.7221C13.3837 12.3435 13.9226 11.8136 13.9226 11.1632V10.0341C13.9226 9.7308 14.1716 9.48598 14.4801 9.48598C14.7886 9.48598 15.0376 9.7308 15.0376 10.0341V11.1632C15.0376 12.4202 13.9969 13.4397 12.7221 13.4397Z' />
		<path d='M10.7336 12.8916H5.37793V14.9964H10.7336V12.8916Z' />
		<path d='M12.3541 9.1352C9.7933 9.1352 7.70825 7.08526 7.70825 4.5676C7.70825 2.04994 9.78958 0 12.3541 0C14.9186 0 16.9999 2.04994 16.9999 4.5676C16.9999 7.08526 14.9149 9.1352 12.3541 9.1352ZM12.3541 0.730816C10.2021 0.730816 8.45158 2.45189 8.45158 4.5676C8.45158 6.68331 10.2021 8.40439 12.3541 8.40439C14.506 8.40439 16.2566 6.68331 16.2566 4.5676C16.2566 2.45189 14.506 0.730816 12.3541 0.730816Z' />
		<path d='M12.354 5.84651C11.2278 5.84651 10.3098 4.94396 10.3098 3.83677C10.3098 2.72958 11.2278 1.82703 12.354 1.82703C13.4801 1.82703 14.3981 2.72958 14.3981 3.83677C14.3981 4.94396 13.4801 5.84651 12.354 5.84651ZM12.354 2.55784C11.6367 2.55784 11.0531 3.13153 11.0531 3.83677C11.0531 4.54201 11.6367 5.1157 12.354 5.1157C13.0713 5.1157 13.6548 4.54201 13.6548 3.83677C13.6548 3.13153 13.0713 2.55784 12.354 2.55784Z' />
		<path d='M14.9706 7.71012C14.9446 7.63338 14.283 5.84654 12.3541 5.84654C10.4251 5.84654 9.74498 7.69185 9.74127 7.71012L9.03882 7.4726C9.325 6.65774 10.3842 5.11572 12.3578 5.11572C14.3313 5.11572 15.3906 6.65774 15.6768 7.4726L14.9743 7.71012H14.9706Z' />
	</svg>
);

export const UserIcon = (props: IconProps) => <Icon component={UserSVG} {...props} />;
// #endregion

// #region Alarm viewer
const AcknowledgeSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M1 6L4.5 10L10.5 1' stroke='white' strokeWidth='2' strokeLinecap='round' />
	</svg>
);

const ClearSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M9.03573 10.4983L13.5689 5.96443C14.1437 5.38954 14.1437 4.4587 13.5689 3.88548L10.1118 0.431163C9.537 -0.143721 8.6063 -0.143721 8.03318 0.431163L3.5 4.96506L9.03406 10.5L9.03573 10.4983Z'
			fill='currentColor'
		/>
		<path
			d='M2.30087 11.8999L12.2088 11.8487C12.4227 11.8487 12.5966 11.6786 12.5999 11.4673C12.6049 11.2494 12.4277 11.0711 12.2071 11.0711L8.37632 11.0678L2.84072 5.59985L0.430594 7.98051C-0.141017 8.54514 -0.14436 9.46141 0.42558 10.0293L2.30087 11.8999Z'
			fill='currentColor'
		/>
	</svg>
);

const OperatorNoteSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M11.0468 2.41472L3.84493 0.0538428C3.2804 -0.131136 2.6734 0.175792 2.48842 0.74032L1.93896 2.41472H11.0468Z' fill='currentColor' />
		<path d='M1.28148 4.42334L0.0537672 8.1654C-0.128471 8.7217 0.167495 9.31775 0.715581 9.51232L1.28011 9.76718V4.42334H1.28148Z' fill='#currentColor' />
		<path
			d='M11.3075 3.15454H3.49456C2.90126 3.15454 2.41895 3.63549 2.41895 4.23016V12.0431C2.41895 12.6364 2.89989 13.1187 3.49456 13.1187H11.3075C11.9008 13.1187 12.3831 12.6378 12.3831 12.0431V4.23016C12.3831 3.63686 11.9022 3.15454 11.3075 3.15454ZM8.44515 10.0248H4.38657C4.192 10.0248 4.0358 9.86722 4.0358 9.67402C4.0358 9.48082 4.19337 9.32325 4.38657 9.32325H8.44515C8.63972 9.32325 8.79592 9.48082 8.79592 9.67402C8.79592 9.86722 8.63835 10.0248 8.44515 10.0248ZM10.4073 8.48879H4.38657C4.192 8.48879 4.0358 8.33121 4.0358 8.13801C4.0358 7.94481 4.19337 7.78724 4.38657 7.78724H10.4073C10.6019 7.78724 10.7581 7.94481 10.7581 8.13801C10.7581 8.33121 10.6005 8.48879 10.4073 8.48879ZM10.4073 6.95141H4.38657C4.192 6.95141 4.0358 6.79383 4.0358 6.60063C4.0358 6.40743 4.19337 6.24986 4.38657 6.24986H10.4073C10.6019 6.24986 10.7581 6.40743 10.7581 6.60063C10.7581 6.79383 10.6005 6.95141 10.4073 6.95141Z'
			fill='currentColor'
		/>
	</svg>
);

const InstructionsSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M1 13.1263C3.92535 11.6637 7.21886 12.5169 8.49994 13.1263V2.86523H1V13.1263Z' fill='#EE9C4E' stroke='white' strokeWidth='0.5' />
		<path d='M16 13.1266C13.0746 11.6639 9.78114 12.5171 8.50006 13.1266V2.86548H16V13.1266Z' fill='#EE9C4E' stroke='white' strokeWidth='0.5' />
		<path d='M8.46289 2.82812L8.46289 13.1639' stroke='white' strokeWidth='0.5' />
		<path d='M2.75391 11.0432C4.99522 9.61156 7.5186 10.4467 8.50013 11.0432V1H2.75391V11.0432Z' fill='#EE9C4E' stroke='white' strokeWidth='0.5' />
		<path d='M14.2461 11.0432C12.0048 9.61156 9.4814 10.4467 8.49987 11.0432V1H14.2461V11.0432Z' fill='#EE9C4E' stroke='white' strokeWidth='0.5' />
		<path
			d='M4.15654 4H6.84346C6.92968 4 7 3.77539 7 3.5C7 3.22461 6.93029 3 6.84346 3H4.15654C4.07032 3 4 3.22461 4 3.5C4 3.77539 4.06971 4 4.15654 4Z'
			fill='white'
		/>
		<path
			d='M10.1565 4H12.8435C12.9297 4 13 3.77539 13 3.5C13 3.22461 12.9303 3 12.8435 3H10.1565C10.0703 3 10 3.22461 10 3.5C10 3.77539 10.0697 4 10.1565 4Z'
			fill='white'
		/>
		<path
			d='M4.15654 7H6.84346C6.92968 7 7 6.77539 7 6.5C7 6.22461 6.93029 6 6.84346 6H4.15654C4.07032 6 4 6.22461 4 6.5C4 6.77539 4.06971 7 4.15654 7Z'
			fill='white'
		/>
		<path
			d='M10.1565 7H12.8435C12.9297 7 13 6.77539 13 6.5C13 6.22461 12.9303 6 12.8435 6H10.1565C10.0703 6 10 6.22461 10 6.5C10 6.77539 10.0697 7 10.1565 7Z'
			fill='white'
		/>
		<path d='M8.4248 1V11.0746' stroke='white' strokeWidth='0.5' />
	</svg>
);

const OperatorNoteDarkSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M11.0473 2.41472L3.84542 0.0538428C3.28089 -0.131136 2.67389 0.175792 2.48891 0.74032L1.93945 2.41472H11.0473Z' fill='#161C2E' />
		<path d='M1.28148 4.42346L0.0537672 8.16552C-0.128471 8.72182 0.167495 9.31787 0.715581 9.51244L1.28011 9.7673V4.42346H1.28148Z' fill='#161C2E' />
		<path
			d='M11.3066 3.15454H3.49359C2.90028 3.15454 2.41797 3.63549 2.41797 4.23016V12.0431C2.41797 12.6364 2.89891 13.1187 3.49359 13.1187H11.3066C11.8999 13.1187 12.3822 12.6378 12.3822 12.0431V4.23016C12.3822 3.63686 11.9012 3.15454 11.3066 3.15454ZM8.44417 10.0248H4.3856C4.19103 10.0248 4.03482 9.86722 4.03482 9.67402C4.03482 9.48082 4.1924 9.32325 4.3856 9.32325H8.44417C8.63874 9.32325 8.79495 9.48082 8.79495 9.67402C8.79495 9.86722 8.63737 10.0248 8.44417 10.0248ZM10.4063 8.48879H4.3856C4.19103 8.48879 4.03482 8.33121 4.03482 8.13801C4.03482 7.94481 4.1924 7.78724 4.3856 7.78724H10.4063C10.6009 7.78724 10.7571 7.94481 10.7571 8.13801C10.7571 8.33121 10.5995 8.48879 10.4063 8.48879ZM10.4063 6.95141H4.3856C4.19103 6.95141 4.03482 6.79383 4.03482 6.60063C4.03482 6.40743 4.1924 6.24986 4.3856 6.24986H10.4063C10.6009 6.24986 10.7571 6.40743 10.7571 6.60063C10.7571 6.79383 10.5995 6.95141 10.4063 6.95141Z'
			fill='#161C2E'
		/>
	</svg>
);

const InstructionsDarkSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M1 13.1263C3.92535 11.6637 7.21886 12.5169 8.49994 13.1263V2.86523H1V13.1263Z' fill='#161C2E' stroke='white' strokeWidth='0.5' />
		<path d='M16 13.1265C13.0746 11.6638 9.78114 12.517 8.50006 13.1265V2.86536H16V13.1265Z' fill='#161C2E' stroke='white' strokeWidth='0.5' />
		<path d='M8.46289 2.82812L8.46289 13.1639' stroke='white' strokeWidth='0.5' />
		<path d='M2.75391 11.0432C4.99522 9.61156 7.5186 10.4467 8.50013 11.0432V1H2.75391V11.0432Z' fill='#161C2E' stroke='white' strokeWidth='0.5' />
		<path d='M14.2461 11.0432C12.0048 9.61156 9.4814 10.4467 8.49987 11.0432V1H14.2461V11.0432Z' fill='#161C2E' stroke='white' strokeWidth='0.5' />
		<path
			d='M4.15654 4H6.84346C6.92968 4 7 3.77539 7 3.5C7 3.22461 6.93029 3 6.84346 3H4.15654C4.07032 3 4 3.22461 4 3.5C4 3.77539 4.06971 4 4.15654 4Z'
			fill='white'
		/>
		<path
			d='M10.1565 4H12.8435C12.9297 4 13 3.77539 13 3.5C13 3.22461 12.9303 3 12.8435 3H10.1565C10.0703 3 10 3.22461 10 3.5C10 3.77539 10.0697 4 10.1565 4Z'
			fill='white'
		/>
		<path
			d='M4.15654 7H6.84346C6.92968 7 7 6.77539 7 6.5C7 6.22461 6.93029 6 6.84346 6H4.15654C4.07032 6 4 6.22461 4 6.5C4 6.77539 4.06971 7 4.15654 7Z'
			fill='white'
		/>
		<path
			d='M10.1565 7H12.8435C12.9297 7 13 6.77539 13 6.5C13 6.22461 12.9303 6 12.8435 6H10.1565C10.0703 6 10 6.22461 10 6.5C10 6.77539 10.0697 7 10.1565 7Z'
			fill='white'
		/>
		<path d='M8.42578 1V11.0746' stroke='white' strokeWidth='0.5' />
	</svg>
);

const PreviewBadgeSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0 2C0 0.895431 0.895431 0 2 0H12C13.1046 0 14 0.895431 14 2V10C14 11.1046 13.1046 12 12 12H2C0.89543 12 0 11.1046 0 10V2ZM5.49049 4.28333C5.49049 4.9921 4.91593 5.56667 4.20716 5.56667C3.4984 5.56667 2.92383 4.9921 2.92383 4.28333C2.92383 3.57457 3.4984 3 4.20716 3C4.91593 3 5.49049 3.57457 5.49049 4.28333ZM1 9.41666C1 8.34722 1.64167 6.20833 4.20833 6.20833C6.775 6.20833 7.41667 8.34722 7.41667 9.41666H1ZM7.5 5C7.5 4.72386 7.72386 4.5 8 4.5H12C12.2761 4.5 12.5 4.72386 12.5 5C12.5 5.27614 12.2761 5.5 12 5.5H8C7.72386 5.5 7.5 5.27614 7.5 5ZM8 6.5C7.72386 6.5 7.5 6.72386 7.5 7C7.5 7.27614 7.72386 7.5 8 7.5H12C12.2761 7.5 12.5 7.27614 12.5 7C12.5 6.72386 12.2761 6.5 12 6.5H8Z'
			fill='white'
		/>
	</svg>
);

const StatusSVG = () => (
	<svg width='1em' height='1em' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<g clipPath='url(#clip0_703_1811)'>
			<path
				d='M7.99923 16C3.5893 16 0 12.4107 0 7.99923C0 3.58777 3.5893 0 7.99923 0C12.4092 0 15.9985 3.5893 15.9985 7.99923C15.9985 12.4092 12.4092 15.9985 7.99923 15.9985V16ZM7.99923 0.812961C4.0372 0.812961 0.812961 4.0372 0.812961 7.99923C0.812961 11.9613 4.0372 15.1855 7.99923 15.1855C11.9613 15.1855 15.1855 11.9613 15.1855 7.99923C15.1855 4.0372 11.9628 0.812961 7.99923 0.812961Z'
				fill='black'
			/>
			<path
				d='M7.69951 11.9214C7.69951 11.9214 7.68417 11.9214 7.67651 11.9214C7.47863 11.9122 7.30837 11.7756 7.25622 11.5854L5.86191 6.5957L5.22995 8.31519C5.16399 8.49619 4.99066 8.61737 4.79739 8.61737H2.45821C2.20359 8.61737 1.99805 8.41183 1.99805 8.1572C1.99805 7.90258 2.20359 7.69703 2.45821 7.69703H4.47681L5.48918 4.94063C5.5582 4.7535 5.74074 4.63232 5.94014 4.63999C6.13955 4.64766 6.31134 4.78418 6.36503 4.97591L7.77161 10.0086L9.1429 6.47913C9.20733 6.31347 9.36072 6.19996 9.53711 6.18615C9.71351 6.17388 9.88224 6.26285 9.9712 6.41624L10.775 7.82128H13.1279C13.3826 7.82128 13.5881 8.02682 13.5881 8.28145C13.5881 8.53607 13.3826 8.74161 13.1279 8.74161H10.5081C10.3424 8.74161 10.1905 8.65265 10.1093 8.51L9.65215 7.71084L8.13054 11.6299C8.06151 11.8079 7.89125 11.9229 7.70105 11.9229L7.69951 11.9214Z'
				fill='black'
			/>
		</g>
		<defs>
			<clipPath id='clip0_703_1811'>
				<rect width='16' height='16' fill='white' />
			</clipPath>
		</defs>
	</svg>
);

export const ClearIcon = (props: IconProps) => <Icon component={ClearSVG} {...props} />;

export const AcknowledgeIcon = (props: IconProps) => <Icon component={AcknowledgeSVG} {...props} />;

export const OperatorNoteIcon = (props: IconProps) => <Icon component={OperatorNoteSVG} {...props} />;

export const OperatorNoteDarkIcon = (props: IconProps) => <Icon component={OperatorNoteDarkSVG} {...props} />;

export const InstructionsIcon = (props: IconProps) => <Icon component={InstructionsSVG} {...props} />;

export const InstructionsDarkIcon = (props: IconProps) => <Icon component={InstructionsDarkSVG} {...props} />;

export const PreviewBadgeIcon = (props: IconProps) => <Icon component={PreviewBadgeSVG} {...props} />;

export const StatusIcon = (props: IconProps) => <Icon component={StatusSVG} {...props} />;

// #endregion

// #region Credentials
const TrashIconCircleSVG = () => (
	<svg viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.000976562' width='20.0396' height='20' rx='10' fill='#C7D8E8' />
		<path
			d='M14.501 5.99999H12.951C12.7118 4.83679 11.6885 4.0015 10.501 4H9.50095C8.3134 4.0015 7.29016 4.83679 7.05096 5.99999H5.50097C5.22483 5.99999 5.00098 6.22384 5.00098 6.49998C5.00098 6.77612 5.22483 7 5.50097 7H6.00096V13.5C6.00263 14.88 7.12095 15.9984 8.50097 16H11.501C12.881 15.9984 13.9993 14.88 14.001 13.5V7H14.501C14.7771 7 15.001 6.77615 15.001 6.50001C15.001 6.22387 14.7771 5.99999 14.501 5.99999ZM9.50098 12.5C9.50098 12.7761 9.27712 13 9.00098 13C8.72482 13 8.50097 12.7761 8.50097 12.5V9.50001C8.50097 9.22387 8.72482 9.00002 9.00096 9.00002C9.2771 9.00002 9.50095 9.22387 9.50095 9.50001V12.5H9.50098ZM11.501 12.5C11.501 12.7761 11.2771 13 11.001 13C10.7248 13 10.501 12.7761 10.501 12.5V9.50001C10.501 9.22387 10.7248 9.00002 11.001 9.00002C11.2771 9.00002 11.501 9.22387 11.501 9.50001V12.5ZM8.08648 5.99999C8.29915 5.40114 8.86549 5.00076 9.50098 4.99998H10.501C11.1365 5.00076 11.7028 5.40114 11.9155 5.99999H8.08648Z'
			fill='#406080'
		/>
	</svg>
);

const GreenEyeSVG = () => (
	<svg width='24' height='24' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='0.000976562' width='20.0396' height='20' rx='10' fill='#00CB22' />
		<g clipPath='url(#clip0_573_970)'>
			<path
				d='M15.9114 9.5905C15.4724 8.6305 13.7509 5.5 10.0009 5.5C6.25091 5.5 4.52941 8.6305 4.09041 9.5905C4.03148 9.71915 4.00098 9.85899 4.00098 10.0005C4.00098 10.142 4.03148 10.2818 4.09041 10.4105C4.52941 11.3695 6.25091 14.5 10.0009 14.5C13.7509 14.5 15.4724 11.3695 15.9114 10.4095C15.9702 10.281 16.0007 10.1413 16.0007 10C16.0007 9.85867 15.9702 9.71901 15.9114 9.5905V9.5905ZM10.0009 13C9.40757 13 8.82755 12.8241 8.3342 12.4944C7.84085 12.1648 7.45634 11.6962 7.22927 11.1481C7.00221 10.5999 6.9428 9.99667 7.05856 9.41473C7.17431 8.83279 7.46003 8.29824 7.87959 7.87868C8.29915 7.45912 8.8337 7.1734 9.41564 7.05764C9.99759 6.94189 10.6008 7.0013 11.149 7.22836C11.6971 7.45542 12.1657 7.83994 12.4953 8.33329C12.825 8.82664 13.0009 9.40666 13.0009 10C13.0001 10.7954 12.6838 11.558 12.1214 12.1204C11.5589 12.6829 10.7963 12.9992 10.0009 13V13Z'
				fill='white'
			/>
			<path
				d='M10.001 12C11.1055 12 12.001 11.1046 12.001 10C12.001 8.89543 11.1055 8 10.001 8C8.89641 8 8.00098 8.89543 8.00098 10C8.00098 11.1046 8.89641 12 10.001 12Z'
				fill='white'
			/>
		</g>
		<defs>
			<clipPath id='clip0_573_970'>
				<rect width='12' height='12' fill='white' transform='translate(4.00098 4)' />
			</clipPath>
		</defs>
	</svg>
);

export const TrashCircleIcon = (props: IconProps) => <Icon component={TrashIconCircleSVG} {...props} />;

export const GreenEyeIcon = (props: IconProps) => <Icon component={GreenEyeSVG} {...props} />;

// #endregion
